module.exports = __webpack_public_path__ + "static/media/avatar.7aea9cc8.png";